export default __webpack_public_path__ + "8243c5bb505ca25b82a69be4aeb41009.png";